<script>
    import { afterUpdate } from 'svelte'

    let overlayTexture0 = './images/overlay/texture0.png'
    let overlayTexture1 = './images/overlay/texture1.png'
    let overlayTexture2 = './images/overlay/texture2.png'
    let overlayTexture3 = './images/overlay/texture3.png'
    let overlayTexture4 = './images/overlay/texture4.png'
    let overlayTexture5 = './images/overlay/texture5.png'
    let overlayTexture6 = './images/overlay/texture6.png'
    let overlayTexture7 = './images/overlay/texture7.png'
    let overlayTexture8 = './images/overlay/texture8.png'
    let overlayTexture9 = './images/overlay/texture9.png'
    let overlayTexture10 = './images/overlay/texture10.png'
    let overlayTexture11 = './images/overlay/texture11.png'

    let cutoutTexture0 = './images/overlay-cutout/texture0.png'
    let cutoutTexture1 = './images/overlay-cutout/texture1.png'
    let cutoutTexture2 = './images/overlay-cutout/texture2.png'
    let cutoutTexture3 = './images/overlay-cutout/texture3.png'
    let cutoutTexture4 = './images/overlay-cutout/texture4.png'
    let cutoutTexture5 = './images/overlay-cutout/texture5.png'
    let cutoutTexture6 = './images/overlay-cutout/texture6.png'
    let cutoutTexture7 = './images/overlay-cutout/texture7.png'
    let cutoutTexture8 = './images/overlay-cutout/texture8.png'
    let cutoutTexture9 = './images/overlay-cutout/texture9.png'
    let cutoutTexture10 = './images/overlay-cutout/texture10.png'
    let cutoutTexture11 = './images/overlay-cutout/texture11.png'

    export let bgColor = ""
    export let chosenPalette

    // Initialize Overlay
    export let overlayEnabled
    let overlayTextures = [
        overlayTexture0,
        overlayTexture1,
        overlayTexture2,
        overlayTexture3,
        overlayTexture4,
        overlayTexture5,
        overlayTexture6,
        overlayTexture7,
        overlayTexture8,
        overlayTexture9,
        overlayTexture10,
        overlayTexture11,
    ]
    let overlayImage = 0
    let overlaySize = 100
    let overlayRotation = 0
    let overlayPositionOptions = ["left top", "left center", "left bottom", "right top", "right center", "right bottom", "center top", "center center", "center bottom"]
    let overlayPosition = "center center"
    let overlayColor = ""

    // Initialize Overlay Cutout
    export let overlayCutoutEnabled
    let cutoutTextures = [
        cutoutTexture0,
        cutoutTexture1,
        cutoutTexture2,
        cutoutTexture3,
        cutoutTexture4,
        cutoutTexture5,
        cutoutTexture6,
        cutoutTexture7,
        cutoutTexture8,
        cutoutTexture9,
        cutoutTexture10,
        cutoutTexture11,
    ]
    let overlayCutoutImage = 0
    let overlayCutoutSize = 100
    let overlayCutoutRotation = 0
    let overlayCutoutPositionOptions = ["left top", "left center", "left bottom", "right top", "right center", "right bottom", "center top", "center center", "center bottom"]
    let overlayCutoutPosition = "center center"

    //Initialize Squiggle Filter
    let squiggleSeed = 0;

    afterUpdate( async () => {
        // Determine Overlay
        if (overlayEnabled) {
            overlayImage = Math.floor( fxrand() * 11 ) // multiply by number of texture options. 0 index
            overlaySize = (Math.floor(fxrand() * 2) * 100) + 100
            overlayRotation = 90 * Math.floor( fxrand() * 3)
            overlayPosition =  overlayPositionOptions[ Math.floor(fxrand() * overlayPositionOptions.length) ]
            overlayColor = chosenPalette.colors[ Math.floor(fxrand() * chosenPalette.colors.length)]
        }

        // Determine Overlay Cutout
        if (overlayCutoutEnabled) {
            overlayCutoutImage = Math.floor( fxrand() * 11 ) // multiply by number of texture options. 0 index
            overlayCutoutSize = (Math.floor(fxrand() * 3) * 100) + 100
            overlayCutoutRotation = 90 * Math.floor( fxrand() * 3)
            overlayCutoutPosition =  overlayCutoutPositionOptions[ Math.floor(fxrand() * overlayCutoutPositionOptions.length) ]
        }

        // Determine squiggle filter seed
        squiggleSeed = Math.floor(fxrand() * 1000)

        // Call preview
        fxpreview() 
    });
</script> 

<style>
    .artboard {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        --r: 595 / 842;
        aspect-ratio: var(--r);
        /* width:min(90%, min(960px, 90vh*(var(--r)))); */
        width: min(90%, min(90vh*(var(--r))));
        overflow: hidden;
        filter: url("#artboard");
        -moz-filter: url("#artboard");
    }

    .overlay {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .overlay-cutout {
        height: 90%;
        width: 90%;
        position: absolute;
        top: 5%;
        left: 5%;
    }
</style>

<div class="artboard" style="background-color: {bgColor}">
    {#if overlayEnabled}
        <div class="overlay" style="background-color: {overlayColor}; -webkit-mask-image: url({overlayTextures[overlayImage]}); -webkit-mask-size: {overlaySize}%; -webkit-mask-position: {overlayPosition}; transform: rotate({overlayRotation}deg)"></div>
    {/if}
    <slot></slot>
    {#if overlayCutoutEnabled}
        <div class="overlay-cutout" style="background-color: {bgColor}; -webkit-mask-image: url({cutoutTextures[overlayCutoutImage]}); -webkit-mask-size: {overlayCutoutSize}%; -webkit-mask-position: {overlayCutoutPosition}; transform: rotate({overlayCutoutRotation}deg)"></div>
    {/if}
</div>

<svg xmlns="http://www.w3.org/2000/svg" version="1.1" style="position: absolute" width="0px" height="0px">
    <defs>
        <filter id="artboard">
            <feTurbulence type="turbulence" baseFrequency=".009" numOctaves="1" result="turbulence" seed="{squiggleSeed}"/>
            <feDisplacementMap in2="turbulence" in="SourceGraphic" result="displacement" scale="1" xChannelSelector="R" yChannelSelector="G" color-interpolation-filters="sRGB"/>
            <feGaussianBlur in="displacement" result="blur" stdDeviation=".5" />
        </filter>
    </defs>
</svg>